import { render } from "./AssignedResourceToTaskTable.vue?vue&type=template&id=36a61fd8&scoped=true&ts=true"
import script from "./AssignedResourceToTaskTable.vue?vue&type=script&lang=ts"
export * from "./AssignedResourceToTaskTable.vue?vue&type=script&lang=ts"

import "./AssignedResourceToTaskTable.vue?vue&type=style&index=0&id=36a61fd8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a61fd8"]])

export default __exports__